import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../../../helpers/api';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import { t } from '../../../../../../i18n';

const infractionsApi = new Api('shifts/:id/worker_infractions');
const formInfoApi = new Api('shifts/:id/worker_infractions/form_data');

function* loadFormData({ payload }) {
  const { id } = payload;

  try {
    const result = yield call(sendRequest, formInfoApi.load, { id }, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      yield put(actions.loadFormDataSuccess({ formInfo: result.data.success.data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* addInfraction({ payload }) {
  const { infraction_type, admin_comments, issued_admin_id, id, cb, onError } = payload;

  try {
    const result = yield call(
      sendRequest,
      infractionsApi.createItem,
      { id, data: { worker_infraction: { infraction_type, admin_comments, issued_admin_id } } },
      notifications.REQUEST_ERROR,
    );

    if (result?.data) {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.added_successfully', {
            item: t('dash.talent.past_jobs.report_modal.infraction_title'),
          }),
        }),
      );

      if (cb) {
        cb();
      }
    } else {
      if (onError) {
        onError();
      }

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.common.notification.default_error_message'),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadFormData), takeEvery(actions.ADD_REQUEST, addInfraction)]);
}
